import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { getActivePartnerProductPricesCount } from '@apis/partner';
import type { GetProductsParams } from '@apis/product';
import { dropEmptyValues } from '@utils/common';

type Params = {
  partnerId: number;
  searchParam: GetProductsParams;
};

const FILTER_KEYS: Array<keyof GetProductsParams> = [
  'productName',
  'countryId',
  'stockId',
  'productStatus',
  'productSaleType',
];

export const useActivePartnerProductPriceCount = ({ partnerId, searchParam }: Params) => {
  const cleaned = dropEmptyValues(searchParam, FILTER_KEYS);

  const queryOptions: UseQueryOptions<number, Error> = {
    // Include cleaned filters to avoid stale count cache across different searches.
    queryKey: ['activePartnerProductPriceCount', partnerId, cleaned],
    queryFn: () => getActivePartnerProductPricesCount(partnerId, cleaned),
    enabled: partnerId > 0,
  };

  return useQuery(queryOptions);
};
